import { View } from "binder"
import { ProducerEditorViewModel } from "./producerEditor-viewModel"

export class ProducerEditorView extends View<ProducerEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-58DC89C3-28D9-4855-8883-D1AFF5131917"
    }
    loadHtml(): string {
        let element = require('./producerEditor.html').default;
        let style = require('./producerEditor.less');
        return element;
    }
    constructor() {
        super();
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set country(v: string) { this._country = v; } public get country(): string { return this._country; } private _country: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    back() {
        this.dataContext.back();
    }

    save() {
        this.dataContext.save();
    }
}
